import { useEffect, useState, useContext } from 'react';
import ReactModal from 'react-modal';
import CUSTOM_STYLES from '../../utils/modalStyle';
import { PriceChangesAvailability } from '@desquared/wave-components-library';
import { priceChangesModalStore } from '@/store/priceChangesStore';
import { fullCartStore, productsForOrder } from '@/store/cart';
import styles from './AgeRestrictedProductsModal.module.css';
import { checkOrder, updatePrices, setCartProducts } from '@/utils/products/products';
import { ReplacementOptionStore } from '@/store/sideSheet';
import User from '@/store/user';
import GuestUserStore from '@/store/guestUser';
import { useRouter } from 'next/router';
import Router from 'next/router';
import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext';
import { onClickRemoveFromOrder } from '@/utils/cart';
import { useTranslations } from 'next-intl';
import useGetDefaultProductImage from '@/hooks/useGetDefaultProductImage.js';
import { IsAddressModalOpen } from '@/store/addressModal.js';
import { useToast } from '@/contexts/ToastContext.jsx';

function AgeRestrictedProductsModal({
  isOpen = true,
  modalClose,
  shouldCloseOnOverlayClick = true,
  isInEditMode = false,
  checkOrderEditHandler,
}) {
  const [categories, setCategories] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [description, setDescription] = useState('');
  const t = useTranslations('common.asides.price_changes');
  const r = useTranslations('common.asides');
  const defaultProductImage = useGetDefaultProductImage(0);
  const router = useRouter();
  const { showToast } = useToast();

  useEffect(() => {
    const ageRestrictedProductsIds = fullCartStore
      .getValue()
      ?.data?.products?.filter(product => product?.needsAgeVerification)
      .map(product => product?._id);

    const ageRestrictedProducts = fullCartStore
      .getValue()
      ?.products?.filter(product => ageRestrictedProductsIds?.includes(product.id));

    const ageRestrictedProductsForDisplay = ageRestrictedProducts?.map(product => {
      return {
        ...product,
        hasDeleteButton: false,
        label: r('age_verification.label'),
        labelType: 'ageRestricted',
        isInAgeRestrictedModal: true,
        userIsOfLegalAge: false,
      };
    });

    const productsForOrder$ = productsForOrder.subscribe((productsOrder = []) => {
      const tempProductsFiltered = setCartProducts(productsOrder);

      setTempProducts(tempProductsFiltered);
    });
    const newCategories = [];

    if (ageRestrictedProductsForDisplay?.length > 0) {
      setDescription(r('age_verification.restricted_products_modal_description'));
      newCategories.push({
        title: r('age_verification.restricted_products_modal_subtitle'),
        items: ageRestrictedProductsForDisplay,
      });
    }
    setCategories(newCategories);
    return () => {
      productsForOrder$.unsubscribe();
    };
  }, []);

  function closeModal() {
    modalClose();
    priceChangesModalStore.update(false);
  }

  const { getCollectionTypes } = useContext(DeliveryServicesContext);
  const onSubmit = () => {
    let filteredArray;

    fullCartStore
      .getValue()
      ?.data?.products?.filter(prod => prod?.needsAgeVerification)
      .forEach(el => {
        productsForOrder.getValue().forEach(ol => {
          if (ol.id === el._id) {
            onClickRemoveFromOrder(ol);
          }
        });
      });

    filteredArray = setCartProducts(productsForOrder.getValue());
    const currentRoute = router.pathname;

    if (isInEditMode) {
      checkOrderEditHandler();
      closeModal();
    } else {
      checkOrder(
        filteredArray,
        ReplacementOptionStore.getValue().option,
        true,
        getCollectionTypes(),
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        r
      ).then(result => {
        if (result && result.data) {
          fullCartStore.update(result);
          const user = User.getValue();
          const guestUser = GuestUserStore.getValue();
          closeModal();
          updatePrices();
          if (guestUser?.email) {
            if (currentRoute !== '/cart') {
              Router.push('/cart', '/cart');
              return;
            } else {
              Router.push('/checkout', '/checkout');
              return;
            }
          }

          if (!user?._id) {
            Router.push('/login', '/login');
            return;
          }
          if (User.getValue()?.address?.length === 0) {
            IsAddressModalOpen.update('open');
            return;
          }

          if (result.products?.length > 0) {
            Router.push('/checkout', '/checkout');
            return;
          }
        }
      });
    }
    showToast(r('age_verification.snackbar'));
  };

  return (
    isOpen && (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={CUSTOM_STYLES}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        className={styles.modalContent}
      >
        <PriceChangesAvailability
          title={r('age_verification.restricted_products_modal_title')}
          description={description}
          submitButton={t('continue')}
          secondaryButton={t('back_to_cart')}
          onSubmit={onSubmit}
          onBackToCart={closeModal}
          categories={categories}
          defaultProductImage={defaultProductImage}
        />
      </ReactModal>
    )
  );
}

export default AgeRestrictedProductsModal;
